import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { GameLandingPage } from "./core/components/GameLandingPage";
import { defaultGameDefinition, getGameBySlug } from "./core/games/gameRegistry";
import { buildGamePath } from "./core/games/gamePaths";

function RootRedirect() {
  return <Navigate to="/" replace />;
}

function LegacyGameRedirect() {
  const { gameId } = useParams();
  return (
    <Navigate
      to={buildGamePath(defaultGameDefinition.slug, gameId)}
      replace
    />
  );
}

function GameRoute() {
  const { gameSlug, gameId } = useParams();
  const gameDefinition = getGameBySlug(gameSlug);

  if (!gameDefinition) {
    return <RootRedirect />;
  }

  const GameComponent = gameDefinition.component;
  return <GameComponent gameDefinition={gameDefinition} gameId={gameId} />;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<GameLandingPage />} />
      <Route path="/game" element={<LegacyGameRedirect />} />
      <Route path="/game/:gameId" element={<LegacyGameRedirect />} />
      <Route path="/games/:gameSlug" element={<GameRoute />} />
      <Route path="/games/:gameSlug/:gameId" element={<GameRoute />} />
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}

export default App;
